<template>
  <aside class="header-ecosystem-menu">
    <BaseButton
      v-if="!isMobile"
      class="close-button"
      icon-left="essential/xmark-clear"
      theme="potato"
      theme-type="outline"
      size="l"
      @click="$emit('close')"
    />
    <p class="title">
      {{ ECOSYSTEM_MENU_TITLE }}
    </p>
    <p class="description">
      {{ ECOSYSTEM_MENU_DESCRIPTION }}
    </p>
    <nav class="menu">
      <ul class="list">
        <template v-if="menuItems?.length">
          <HeaderEcosystemItem
            v-for="(item, index) in menuItems"
            :key="`ecosystem-item-${index}`"
            :title="item.name"
            :description="item.content"
            :image="item.image"
            :link="item.link"
          />
        </template>
      </ul>
    </nav>
  </aside>
</template>

<script setup lang="ts">
  import { HeaderEcosystemItem } from '~/components/layouts/header/ecosystem/index'
  import { BaseButton } from '~/components/base-ui/buttons'

  defineEmits(['close'])

  const ECOSYSTEM_MENU_TITLE: string = 'Экосистема Своё'
  const ECOSYSTEM_MENU_DESCRIPTION: string =
    'Технологии для развития сельского хозяйства в едином цифровом пространстве'

  const { $services } = useNuxtApp()
  const { isMobile } = useBreakpoint()

  const { data: menuItems} = await useAsyncData(
    `menu-ecosystem`,
    async () => await $services.ecosystemService.getOtherServicesMenuList()
  )
</script>

<style lang="scss" scoped>
  .header-ecosystem-menu {
    position: relative;
    padding: 40px 48px;

    @include vp-767 {
      padding: 0;
      margin: -16px;
    }

    > .close-button {
      position: absolute;
      top: 24px;
      right: 23px;
    }

    > .title {
      font-size: 28px;
      font-weight: 500;
      line-height: 36px;
      margin-bottom: 8px;

      @include vp-1439 {
        font-size: 24px;
        line-height: 32px;
      }

      @include vp-767 {
        text-align: center;
        font-size: 20px;
        line-height: 28px;
      }
    }

    > .description {
      font-size: 18px;
      font-weight: 400;
      line-height: 26px;
      color: $color-potato-70;

      @include vp-1439 {
        font-size: 16px;
        line-height: 24px;
      }

      @include vp-767 {
        text-align: center;
        font-size: 14px;
        line-height: 22px;
      }
    }

    > .menu {
      @include vp-1439 {
        max-height: 324px;
        overflow: auto;
        padding-right: 16px;
      }

      @include vp-767 {
        max-height: calc(100vh - 164px);
      }
    }

    > .menu > .list {
      @include list-reset;

      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 40px;
      margin: 16px -16px 0;

      @include vp-1439 {
        margin: 16px 0 0;
        gap: 16px;
        grid-template-columns: 1fr;
      }

      @include vp-767 {
        max-height: 60vh;
      }
    }
  }
</style>
